'use client'

import {useEffect, type CSSProperties} from 'react'

let users = 0
let release: (() => void) | undefined

/** Shared viewport geometry only. It never positions actions or detects a keyboard. */
export function useVisualViewport(enabled = true) {
    useEffect(() => {
        if (!enabled) return
        if (users++ === 0) {
            const root = document.documentElement
            const viewport = window.visualViewport
            const properties = ['--fitro-vv-height', '--fitro-vv-width', '--fitro-vv-offset-top', '--fitro-vv-offset-left']
            const previous = properties.map(name => root.style.getPropertyValue(name))
            const update = () => {
                const values = [viewport?.height ?? window.innerHeight, viewport?.width ?? window.innerWidth,
                    viewport?.offsetTop ?? 0, viewport?.offsetLeft ?? 0]
                properties.forEach((name, index) => root.style.setProperty(name, `${values[index]}px`))
            }
            update()
            viewport?.addEventListener('resize', update, {passive: true})
            viewport?.addEventListener('scroll', update, {passive: true})
            window.addEventListener('resize', update, {passive: true})
            release = () => {
                viewport?.removeEventListener('resize', update)
                viewport?.removeEventListener('scroll', update)
                window.removeEventListener('resize', update)
                properties.forEach((name, index) => previous[index]
                    ? root.style.setProperty(name, previous[index]) : root.style.removeProperty(name))
            }
        }
        return () => {
            if (--users === 0) {
                release?.()
                release = undefined
            }
        }
    }, [enabled])
}

export const visualViewportStyle: CSSProperties = {
    top: 'var(--fitro-vv-offset-top, 0px)',
    left: 'var(--fitro-vv-offset-left, 0px)',
    width: 'var(--fitro-vv-width, 100%)',
    height: 'var(--fitro-vv-height, 100dvh)',
}
